<div class="day-range-selector" #selector>
  <div class="day-range-selector-item"
       *ngFor="let day of week;let $i = index"
       [ngClass]="{'selected':(selected == $i || selected_end == $i),
       'selected-between': ($i > selected && $i < selected_end)}"
       (click)="selectDay($i)">{{day.label}}
  </div>
</div>
